import { useState } from 'react'
import styled from 'styled-components'
import { Typography } from '@mui/material'
import { useMedia } from 'react-use'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper";

const Wrapper = styled.div`
	background: #0C0720;
	display: flex;
	flex-direction: column;
	align-items: center;
	position:relative;
	top:0px;
	padding:200px 0px;
	width: 100%;

	.swiper-button-next {
		display: none !important;
	}

	.swiper-button-prev {
		display: none !important;
	}

	& .with-gradient {
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		}
	& .pagination {
		position: absolute;
		bottom: 100px;
		left: 50%;
		width:100px;
	}
	& .swiper-pagination-bullet {
		background-color: #5F47EE;
	}
	@media(max-width:640px){
		& .pagination{
			position: absolute;
			bottom: 120px;
			left: 40%;
			width:100px;
		}
	}
`
const Card = styled.div`
	max-width: 408px;
	background: #5F47EE;
	border-radius: 8px;
	padding: 32px;
	width: 95%;
	height:542px;
	display: flex;
	flex-direction: column;
	@media(max-width:705px){
		margin: 0px;
	}
`
const Title = styled.div`
	font-family: 'Poppins';
	font-style: normal;
	font-weight: 700;
	font-size: 50px;
	line-height: 64px;
	letter-spacing: -1px;
	text-transform: uppercase;
	color: #FCFCFC;
	@media(max-width:768px){
		font-size:40px;
	}
`
const Image = styled.img`
	width: 220px;
	height: 220px;
	margin: 16px auto;
`
const Shadow = styled.div`
	width: 160px;
	height: 700px;
	z-index:10;
	background:  linear-gradient(269.11deg, rgba(12, 7, 32, 0) 8.41%, #0C0720 91.68%);
`
const Shadow2 = styled.div`
	width: calc(320px + 3vw);
	height: 700px;
	z-index:10;
	background:  linear-gradient(269.11deg, #0C0720 30.41%, rgba(12, 7, 32, 0) 69.68%);
`
const ShadowArea = styled.div`
	position:absolute;
	max-width:1450px;
	width:calc(100% - 3vw);
	display:flex;
	justify-content:space-between;
`
const SupplyCard = (props: any) => {
	return (
		<Card>
			<Title>{props.title}</Title>
			<Image src={`assets/svg/deco-${props.index}.png`} />
			<Typography variant='button' color='#FCFCFC' sx={{ textTransform: 'none', fontWeight: '300' }}>{props.description}</Typography>
		</Card>
	)
}

const Distribution = () => {
	const isMobile = useMedia('(max-width:705px)')
	const [paginationRef, setPaginationRef] = useState<HTMLElement | null>(null);

	return (
		<Wrapper id="Features">
			<Typography variant='h3' color='white' sx={{ textAlign: 'center' }}>Why people love Robust?</Typography>
			<Typography variant='h6' color='#FCFCFC' sx={{ maxWidth: '816px', textAlign: 'center', mt: '16px' }}>Designed with an aggressive deflationary mechanism with the aim of growing the value of the token as the project matures.</Typography>
			<div className="with-gradient" style={{ maxWidth: '1440px', width: '100%', marginTop: '5vh', paddingLeft: isMobile ? '5vw' : '3vw' }}>
				{!isMobile &&
					<ShadowArea>
						<Shadow />
						<Shadow2 />
					</ShadowArea>
				}
				<Swiper
					focusableElements='input, select, option, textarea, button, video, label'
					noSwipingSelector='input'
					grabCursor={true}
					slideVisibleClass="visible"
					watchSlidesProgress={true}
					pagination={{
						clickable: false,
						el: paginationRef,
					}}
					loop={true}
					navigation={{
						enabled: false
					}}
					slidesPerView={3}
					spaceBetween={5}
					breakpoints={{
						360: {
							slidesPerView: 1,
							spaceBetween: 5,
						},
						480: {
							slidesPerView: 1,
							spaceBetween: 5,
						},
						640: {
							slidesPerView: 2,
							spaceBetween: 5,
						},
						1024: {
							slidesPerView: 3,
							spaceBetween: 5,
						},
					}}
					modules={[Autoplay, Pagination, Navigation]}
					className="mySwiper"
					autoplay={{
						delay: 3000,
						disableOnInteraction: false,
					}}
					scrollbar={{
						draggable: true,
					}}
					style={{
						paddingLeft: '0.8vw'
					}}
				>
					<SwiperSlide><SupplyCard index={1} title='Limited Total Supply' description='At launch, a total of 100 000 RBT was created, with 50 000 deposited and locked into the RBT Reserve. No more RBT can ever be created.' /></SwiperSlide>
					<SwiperSlide><SupplyCard index={2} title='Deflation Mechanism' description='Every RBT transfer incurs a 1% fee that gets burned. Effectively, every transaction contributes to the reduction of the total supply of RBT.' /></SwiperSlide>
					<SwiperSlide><SupplyCard index={3} title='Community Governed' description='RBT and all subsequent project will be community governed project. As shareholders, RBW holders will have voting rights.' /></SwiperSlide>
					<SwiperSlide><SupplyCard index={4} title='Loyalty Reward' description='Every time a RBT transaction occurs, 1% of the total amount of the transaction is deducted, burned, and converted into RBW.' /></SwiperSlide>
					<SwiperSlide><SupplyCard index={5} title='Fair share, No Presale' description='40% of the total supply of RBT was provided as liquidity on Pancakeswap and burned. While 50% is time-locked in theRBT Reserve.' /></SwiperSlide>
					<SwiperSlide><SupplyCard index={6} title='15-day Timelock' description='There is a 15-day timelock delay on both the RBT and Reserve smart contracts. RBW holders can vote to implement some changes.' /></SwiperSlide>
				</Swiper>
			</div>
			{isMobile &&
				<div ref={(node) => setPaginationRef(node)} className='pagination' />
			}
		</Wrapper>
	)
}

export default Distribution